<template lang="pug">
.caracteristicas-fisicas
  .empty-data-text(v-if="!evaluacionByRefugioNro") Evaluación de albergues pendiente de realización
  .superficies(v-if="evaluacionByRefugioNro")
    TwoColumnDataPanel(:obj="superficieData")
  .datos-container(v-if="evaluacionByRefugioNro")
    TwoColumnDataPanel(title="Servicios Básicos")
    .datos-row.ticket-info-row
      .datos-column1
      .datos-column2
        TicketInfo(title="Agua", icon="ap-agua", :icon-invert-color="true")
          template(slot="values")
            div
              span.label {{getData(evaluacionByCurrentRefugioNro.agua).forma || '-'}}
        TicketInfo(title="Canillas", icon="ap-acceso-agua", :icon-invert-color="true")
          template(slot="values")
            div(v-if="getData(evaluacionByCurrentRefugioNro.agua).cantidad")
              span.amount {{getData(evaluacionByCurrentRefugioNro.agua).cantidad || '-'}}
              span.label  CANILLAS
            div(v-if="!getData(evaluacionByCurrentRefugioNro.agua).cantidad || getData(evaluacionByCurrentRefugioNro.agua).condicion")
              span.label {{getData(evaluacionByCurrentRefugioNro.agua).condicion}}
        TicketInfo(title="Baños", icon="ap-acceso-bano", :icon-invert-color="true")
          template(slot="values")
            div
              span.amount {{getData(evaluacionByCurrentRefugioNro.baño).cantidad || '-'}}
              span.label(v-if="getData(evaluacionByCurrentRefugioNro.baño).cantidad")  BAÑOS
            div
              span.label {{getData(evaluacionByCurrentRefugioNro.baño).condicion || ''}}
        TicketInfo(title="Sistema", icon="ap-sistema-evacuacion", :icon-invert-color="true")
          template(slot="values")
            div
              span.label {{getData(evaluacionByCurrentRefugioNro.baño).sistema || '-'}}
        TicketInfo(title="Aseo de los baños", icon="ap-aseo-bano", :icon-invert-color="true")
          template(slot="values")
            div
              span.label {{getData(evaluacionByCurrentRefugioNro.baño).frecuenciaAseo || '-'}}
        TicketInfo(title="Duchas", icon="ap-acceso-ducha", :icon-invert-color="true")
          template(slot="values")
            div(v-if="getData(evaluacionByCurrentRefugioNro.duchas).cantidad")
              span.amount {{getData(evaluacionByCurrentRefugioNro.duchas).cantidad || '-'}}
              span.label(v-if="getData(evaluacionByCurrentRefugioNro.duchas).cantidad")  DUCHAS
            div(v-if="getData(evaluacionByCurrentRefugioNro.duchas).sexadas")
              span.label {{getData(evaluacionByCurrentRefugioNro.duchas).sexadas}}
            div(v-if="!getData(evaluacionByCurrentRefugioNro.duchas).cantidad")
              span.label {{getData(evaluacionByCurrentRefugioNro.duchas).hayDuchas || ''}}
        TicketInfo(title="Conexión eléctrica", icon="ap-conexion-electrica", :icon-invert-color="true")
          template(slot="values")
            div
              span.label {{evaluacionByCurrentRefugioNro.conexionElectrica || '-'}}
        TicketInfo(title="Sistema de Recolección de basura", icon="ap-desecho-residuos", :icon-invert-color="true")
          template(slot="values")
            div
              span.label {{evaluacionByCurrentRefugioNro.recoleccionBasura || '-'}}
        TicketInfo(title="Área de lavandería", icon="ap-lavanderia", :icon-invert-color="true")
          template(slot="values")
            div
              span.label {{evaluacionByCurrentRefugioNro.areaLavanderia || '-'}}
        TicketInfo(title="Área médica", icon="ap-area-medica", :icon-invert-color="true")
          template(slot="values")
            div
              span.label {{evaluacionByCurrentRefugioNro.areaMedica || '-'}}
        TicketInfo(title="Acceso para discapacitados", icon="ap-acceso-discapacitados", :icon-invert-color="true")
          template(slot="values")
            div
              span.label {{evaluacionByCurrentRefugioNro.accesoDiscapacitados || '-'}}
        TicketInfo(title="Plan de evacuación", icon="ap-plan-evacuacion", :icon-invert-color="true")
          template(slot="values")
            div
              span.label {{evaluacionByCurrentRefugioNro.planEvacuacion || '-'}}
</template>

<script>
import { mapGetters } from 'vuex'
import { round } from '@/utils/number.js'
import { getData } from '@/utils/object.js'

export default {
  data: () => ({
    superficieData: null
  }),
  mounted () {
    this.loadData()
  },
  methods: {
    getData,
    loadData () {
      this.superficieData = {
        'Uso frecuente': '-',
        'Infraestructura': '-',
        'Superficie del Albergue': '-',
        'Amenazas': '-'
      }
      if (this.evaluacionByRefugioNro) {
        const superficie = parseInt(round(this.evaluacionByCurrentRefugioNro.superficie_albergue))
        this.superficieData = {
          'Uso frecuente': this.evaluacionByCurrentRefugioNro.uso_frecuente,
          'Infraestructura': this.evaluacionByCurrentRefugioNro.infraestructura,
          'Superficie del Albergue': superficie ? `${superficie} m²` : '-',
          'Amenazas': this.evaluacionByCurrentRefugioNro.amenazas
        }
      }
    }
  },
  computed: {
    ...mapGetters({ evaluacionByRefugioNro: 'evaluacionByCurrentRefugioNro' }),
    evaluacionByCurrentRefugioNro () {
      return getData(this.evaluacionByRefugioNro)
    }
  },
  watch: {
    evaluacionByCurrentRefugioNro () {
      this.loadData()
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/variables'

$label-color = #878787
$circulo = $f65px
$semicirculo = ($circulo / 2)
$datos-sexos-height = $f32px

.caracteristicas-fisicas
  .servicios-basicos
    margin-top: 15px
  & >>>
    .mapper
      .flex.key, .flex.value
        font-size: $f17px

.datos-container
  margin-top: $f20px
  white-space: normal
  i
    color: $color_0
    margin: 0 $f5px 0 0

  .datos-row
    display: flex

  .datos-column1
    flex: 0 0 2%

  .datos-column2
    flex: 1 1 64%
    border-left: 2px solid $color_0

  .amount,
  .label
    color: $label-color
  .amount
    font-weight: bold

  .row1
    & .datos-column1
      flex: 1 1 36%
    & .datos-column2
      flex: 1 1 64%
    & .datos-column1,
    & .datos-column2
      display: flex
      justify-content: flex-start
      align-items: flex-end
      span
        flex: 1 1 70%
        max-height: $circulo
      .amount
        font-weight: bold
        font-size: $f38px
      .label
        font-size: $f10px

  .datos-column1
    &.familias
      position: relative
      .label
        font-weight: bold
      .ap-familias-estadisticas
        font-size: $f90px
        flex: 1 1 40%
      span
        border-right: 2px solid $color_0
        flex: 1 1 30%
        padding-right: $f3px

  .datos-column2
    &.sexos
      span
        border-left: 2px solid $color_0
        flex: 1 1 85%
        height: $circulo
        padding-left: $f4px
      span,
      .datos-sexos-info
        display: flex
        justify-content: space-between
        flex-direction: column
      .datos-sexos
        display: flex
        &.female
          margin-top: - $f10px
        &.male
          margin-bottom: - $f16px
      .datos-circulo-separator
        flex: 1 1 15%
      .datos-sexos-icon
        font-size: $datos-sexos-height
      .datos-sexos-info
        .amount
          font-size: $f20px
        .label
          font-size: $f10px

  .datos-circulo
    background-color: $color_0
    border-radius: 50%
    height: $circulo
    position: absolute
    width: $circulo
    color: white
    right: - ($semicirculo + $f1px)
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    font-weight: bold
    line-height: 1
    .number
      font-size: $f36px
    .asu-title
      margin-top: - $f5px
      font-size: $f11px

  .datos-circulo-separator
    flex: 1 1 30%
    height: $circulo
    .line
      background-color: $color_0
      height: $f2px
      width: 100%

</style>
